import { StatusOrderExplicationComponent } from './../status-order-explication/status-order-explication.component';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';

import { DatatableComponent, ColumnMode } from '@swimlane/ngx-datatable';
import { NgbModal, ModalDismissReasons, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { ToastrService } from 'ngx-toastr';

// Component
import { OrderManagementComponent } from '../order-management/order-management.component';
import { OrderDetailsComponent } from '../order-details/order-details.component';
import { DeliveryEstimateComponent } from '../delivery-estimate/delivery-estimate.component';
import { OrderDeleteComponent } from '../order-delete/order-delete.component';

// services
import { OrdersService } from '../services/orders.service';
import { ShopsService } from './../services/shops.service';
import { ProvidersService } from './../services/providers.service';

// Interface
import { OrderModel } from '../interfaces/order.model';
import { AuthService } from '../services/auth.service';
import { TranslateService } from '@ngx-translate/core';


@Component({
    selector: 'app-orders',
    templateUrl: './orders.component.html',
    styleUrls: ['./orders.component.scss'],
})
export class OrdersComponent implements OnInit {

    @BlockUI() blockUI: NgBlockUI;
    @ViewChild(DatatableComponent, { static: false }) table: DatatableComponent;

    ColumnMode = ColumnMode;
    columns = [
        { prop: 'date', name: 'Date <i class="fa fa-sort sort-icon"></i></span>' },
        { prop: 'clientId', name: 'Client (identifiant) <i class="fa fa-sort sort-icon"></i></span>' },
        { prop: 'id_web', name: 'Numéro commande <i class="fa fa-sort sort-icon"></i></span>' },
        { prop: 'parentId', name: 'Identifiant de la commande <i class="fa fa-sort sort-icon"></i></span>' },
        { prop: 'shop', name: 'Adhérents <i class="fa fa-sort sort-icon"></i></span>' },
        { prop: 'status', name: 'Statut <i class="fa fa-question-circle hint status-modal"></i></span> <i class="fa fa-sort sort-icon"></i></span>' },
        { prop: 'pose', name: 'Pose <i class="fa fa-sort sort-icon"></i></span>' },
        { prop: 'cote', name: 'Cotes <i class="fa fa-sort sort-icon"></i></span>' },
        { prop: 'btn_payment', name: 'Étape de la commande' },
        { prop: 'btn_estimation', name: 'Expédition/Livraison' },
        { prop: 'comment', name: 'Commentaire' },
        { prop: 'btn_show', name: 'Voir la commande' },
    ];

    ngAfterViewInit() {
        this.initDataTable();
    }

    statusConfigDataTableOrder = {
        cancelled: {
            status: 'Annulé',
            btn_payment: 'Supprimer',
            btn_estimation: 'Annulé',
            btn_show: 'Voir',
            comment: 'Web-to-Store'
        },
        refunded: {
            status: 'Annulé',
            btn_payment: 'Supprimer',
            btn_estimation: 'Annulé',
            btn_show: 'Voir',
        },
        ['to-refund']: {
            status: 'Annulé',
            btn_payment: 'Annulé',
            btn_estimation: 'Annulé',
            btn_show: 'Voir',
        },
        pending: {
            status: 'À payer',
            btn_payment: 'Modifier',
            btn_estimation: 'Estimer',
            btn_show: 'Voir',
        },
        ["on-hold"]: {
            status: 'À payer',
            btn_payment: 'Modifier',
            btn_estimation: 'Estimer',
            btn_show: 'Voir',
        },
        ['to-process']: {
            status: 'En attente',
            btn_payment: 'Modifier',
            btn_estimation: 'Estimer',
            btn_show: 'Voir',
        },
        processing: {
            status: 'En préparation',
            btn_payment: 'Modifier',
            btn_estimation: 'Estimer',
            btn_show: 'Voir',
        },
        completed: {
            status: 'Livré',
            btn_payment: 'Livré',
            btn_estimation: 'Livré',
            btn_show: 'Voir',
        },
        ['shipped']: {
            status: 'Expédié',
            btn_payment: 'Modifier',
            btn_estimation: 'Livraison',
            btn_show: 'Voir',
        },
        sent: {
            status: 'Expédié',
            btn_payment: 'Expédié',
            btn_estimation: 'Expédié',
            btn_show: 'Voir',
        }
    };
    empty_msgFr = {
        'emptyMessage': ''
    };
    shopName: any;

    constructor(
        private ordersService: OrdersService,
        private fb: FormBuilder,
        private orderModalService: NgbModal,
        private toastrService: ToastrService,
        private shopsService: ShopsService,
        private hintModalService: NgbModal,
        private authService: AuthService,
        private providersService: ProvidersService,
        private translate: TranslateService
    ) {
        translate.get('Aucune donnée disponible', { value: '' })
            .subscribe((res: string) => this.empty_msgFr.emptyMessage = res);
    }

    orders: Array<OrderModel> = [];
    role: string;

    network;
    onTwoNetworks: boolean = false;
    selectedNetwork: string = 'MDM';
    id_org_internal: string;

    searchForm: FormGroup;
    isVisible = false;
    isVisible2 = false;
    isShowChangStatus = false;
    totalItems: number;
    pageIndex: number = 1;
    pageSize: number = 10;
    ordersShipping;
    ShippingDate = 'Mon Apr 05 2021 15:50:48 GMT+0200';
    ordersShippingDetail;
    radioValue;
    status;
    refuserValue;
    clientId;
    id_web;
    showInput = false;
    parent_id;
    totale;
    payment_method;
    firstName;
    secondeName;
    showDetailModal = false;
    seleclectOder;
    type = 1;
    currentPage: number = 1;
    collectionSize: number;
    start: number = 0;
    searchField: string = "";
    orderBy: string = "date";
    orderAsc: boolean = false;
    statusOrder: string = "";
    searchOption: string;
    searchObjet: object;
    idShopSearch: string;
    idShop: string;
    idProvider: string;
    nbShopTotal: number;
    listShops: []
    orderDate: string = "newest-date";

    dataPDF: {
        shop: {
            name: string,
            address: string,
            cp: string,
            city: string,
            phone: string,
            email: string
        }
        userIsShop: Boolean,
    }

    ngOnInit(): void {
        this.searchForm = this.fb.group({
            id: [null],
            status: [null],
            shop: [null],
        });
        // this.getAllShops();
        this.getRole();
    }

    getRole(): void {
        this.blockUI.start('Loading');

        const token = localStorage.getItem('token');

        this.authService.decodeJWT(token).subscribe(
            (res) => {
                if (res.success) {
                    this.role = res.data.role;
                    switch (this.role) {
                        case ("Provider"):
                            this.idProvider = res.data.id_org_internal;
                            this.idShop = "";
                            this.getProviderDetailById();
                            break;
                        case ("Shop"):
                            this.idShop = res.data.id_org_internal;
                            this.idProvider = "";
                            this.getShopDetailById();
                            break;
                        case ("Admin"):
                            this.columns = this.columns.filter(c => {
                                return c.name !== "Étape de la commande" && c.name !== "Livraison";
                            });
                            this.onTwoNetworks = true;
                            this.getAllOrders();
                            break;
                    }

                    if (this.role !== 'Shop') {
                        this.dataPDF = {
                            shop: {
                                name: undefined,
                                address: undefined,
                                cp: undefined,
                                city: undefined,
                                phone: undefined,
                                email: undefined
                            },
                            userIsShop: false
                        }
                    }

                    this.blockUI.stop();
                } else {
                    this.blockUI.stop();
                }
            },
            (error) => {
                this.blockUI.stop();
            }
        );
    }

    getShopDetailById() {
        this.blockUI.start('Loading');

        const token = localStorage.getItem('token');

        this.authService.decodeJWT(token).subscribe(
            (res: any) => {
                if (res.success) {
                    this.id_org_internal = res.data.id_org_internal;

                    this.shopsService.getShopDetailById(this.id_org_internal).subscribe(
                        (res) => {
                            if (res.success) {

                                this.network = res.data.network;

                                this.dataPDF = {
                                    shop: {
                                        name: res.data.shopName,
                                        address: res.data.shopAddress,
                                        cp: res.data.shopPostalCode,
                                        city: res.data.shopCity,
                                        phone: res.data.telephoneNumber,
                                        email: res.data.email
                                    },
                                    userIsShop: true
                                }

                                if (this.network.includes('SM') && this.network.length === 1) {
                                    this.selectedNetwork = 'SM';
                                }

                                if (this.network.length === 2) {
                                    this.onTwoNetworks = true;
                                }

                                this.getAllOrders();
                                this.blockUI.stop();

                            } else {
                                this.blockUI.stop();
                                if (res.errorSet.includes('ERROR_SERVER')) {
                                    this.toastrService.error('Une erreur serveur est survenue');
                                }
                            }
                        },
                        (error) => {
                            this.blockUI.stop();
                            this.toastrService.error('Une erreur s\'est produite');
                        }
                    );
                }
            },
            (error) => {
                this.blockUI.stop();
                this.toastrService.error('Une erreur s\'est produite');
            }
        );
    }

    getProviderDetailById() {
        this.blockUI.start('Loading');

        const token = localStorage.getItem('token');

        this.authService.decodeJWT(token).subscribe(
            (res: any) => {
                if (res.success) {
                    this.id_org_internal = res.data.id_org_internal;
                    this.providersService.getProviderDetailById(this.id_org_internal).subscribe(
                        (res) => {
                            if (res.success) {

                                this.network = res.data.network;
                                if (this.network.includes('SM') && this.network.length == 1) {
                                    this.selectedNetwork = 'SM';
                                }

                                if (this.network.length === 2) {
                                    this.onTwoNetworks = true;
                                }

                                this.getAllOrders();
                                this.blockUI.stop();

                            } else {
                                this.blockUI.stop();
                                if (res.errorSet.includes('ERROR_SERVER')) {
                                    this.toastrService.error('Une erreur serveur est survenue');
                                }
                            }
                        },
                        (error) => {
                            this.blockUI.stop();
                            this.toastrService.error('Une erreur s\'est produite');
                        }
                    );
                } else {
                    this.blockUI.stop();
                    if (res.errorSet.includes('InvalidRequest')) {
                        this.toastrService.error('Les paramètres sont invalides');
                    } else if (res.errorSet.includes('TokenError')) {
                        this.toastrService.error('Token non trouvé ou invalidé');
                    }
                }
            },
            (error) => {
                this.blockUI.stop();
                this.toastrService.error('Une erreur s\'est produite');
            }
        );
    }

    public openOrderManagement(order: OrderModel) {
        const modalRef = this.orderModalService.open(OrderManagementComponent);
        modalRef.componentInstance.order = order;
        modalRef.componentInstance.network = this.selectedNetwork;
        modalRef.componentInstance.updateData.subscribe(($ev: { status: string, message: string }) => {
            if ($ev.status === 'success') {
                this.getAllOrders();
            }
            this.toastrService[$ev.status]($ev.message);
        })
    }
    public openOrderdelete(order: OrderModel) {
        const modalRef = this.orderModalService.open(OrderDeleteComponent, { centered: true });
        modalRef.componentInstance.order = order;
        modalRef.componentInstance.network = this.selectedNetwork;

        modalRef.componentInstance.updateData.subscribe(($ev: { status: string, message: string }) => {
            if ($ev.status === 'success') {
                this.getAllOrders();
            }
            this.toastrService[$ev.status]($ev.message);
        })
    }

    public openDeliveryEstimate(order: OrderModel) {
        const modalRef = this.orderModalService.open(DeliveryEstimateComponent);
        modalRef.componentInstance.order = order;
        modalRef.componentInstance.network = this.selectedNetwork;

        modalRef.componentInstance.updateEstimateDate.subscribe(($ev: { status: string, message: string }) => {
            if ($ev.status === 'success') {
                this.getAllOrders();
            }
            this.toastrService[$ev.status]($ev.message);
        })
    }

    public showOrderDetails(order: OrderModel) {
        const modalRef = this.orderModalService.open(OrderDetailsComponent);
        modalRef.componentInstance.order = order;
        modalRef.componentInstance.network = this.selectedNetwork;
        modalRef.componentInstance.dataPDF = this.dataPDF;
        modalRef.componentInstance.role = this.role;
    }

    getOrdersByNetwork(event): void {
        this.selectedNetwork = event.value;
        this.getAllOrders();
    }

    private getAllOrders(): void {
        this.blockUI.start('Loading');

        const query = Object.keys(this.searchForm.value)
            .map((key) => key + '=' + this.searchForm.value[key])
            .join('&');

        let data: any;

        data = {
            network: this.selectedNetwork,
            idProvider: this.idProvider,
            idShop: this.idShop,
            shopName: this.shopName,
            nbByPage: this.pageSize,
            start: this.start,
            orderBy: this.orderBy,
            orderAsc: this.orderAsc,
            status: this.statusOrder,
            search: this.searchObjet
        }

        this.ordersService.getOrders(data).subscribe(
            (res) => {
                if (res.success) {
                    this.orders = res.data;
                    console.log(res.data)
                    // format date add 2 hours
                    this.orders.forEach(order => {
                        order.date = new Date(order.date);
                        order.id_web = "Web-" + (order.id_web ?? 0),
                        order.comment = order.blocageMetrage?.value || order.blocageUsine?.value,
                        order.date.setHours(order.date.getHours() + 2);
                    });

                    // this.collectionSize = this.searchField === "" ? res.nbOrderTotal : res.nbOrderFiltered;
                    this.collectionSize = res.nbOrderFiltered;
                    this.fixBrowserTooltip();
                    this.blockUI.stop();

                } else {
                    this.blockUI.stop();

                    if (res.errorSet.includes('INVALID_PARAMS')) {
                        this.toastrService.error('Les paramètres sont invalides');
                    } else if (res.errorSet.includes('ERROR_SERVER')) {
                        this.toastrService.error('Une erreur serveur est survenue');
                    } else {
                        this.toastrService.error('Une erreur s\'est produite');
                    }
                }
            },
            (error) => {
                this.blockUI.stop();
                console.error(error);
                this.toastrService.error('Une erreur s\'est produite');
            }
        );
    }

    onSearchChange(value: any) {

        if (!this.searchOption) {
            this.toastrService.warning('Veuillez selectionner une option pour la recherche');
        };

        switch (this.searchOption) {
            case "client":
                {

                    this.searchObjet = {
                        idClient: parseInt(this.searchField)
                    };

                    // si le champ recherche est vide on reset le tableau
                    // pour récuperer toute les commandes
                    if (!this.searchField) {
                        this.searchObjet = {};
                    };

                    // // on verifie que le champ soit un numèro ou qu'il soit égale à 0 ou qu'il soit vide
                    // // pour appeler la méthode
                    if (parseInt(this.searchField) || parseInt(this.searchField) === 0 || !this.searchField) {
                        this.getAllOrders();

                    } else {
                        this.toastrService.error('Veuillez renseigner uniquement des chiffres');
                    };

                    break;
                }
            case "order":
                {
                    this.searchObjet = {
                        idOrder: this.searchField
                    };
                    this.getAllOrders();
                    break;
                }
            case "shop":
                {
                    this.searchObjet = {
                        shopName: this.searchField
                    };
                    this.getAllOrders();
                    break;
                }
        }
    }

    resetSearch() {
        if (this.searchField) {
            this.searchObjet = {};
            this.getAllOrders();
            this.searchField = "";
        }
    }

    resetSearchField() {
        if (this.searchField || this.idShopSearch) {
            this.searchObjet = {};
            this.getAllOrders();
        }
        this.idShopSearch = "";
        this.searchField = "";
    }

    onPageChange(currentPage: number) {
        this.start = currentPage * this.pageSize - this.pageSize;
        this.getAllOrders();
    }

    toggleFilter() {
        let tableFilter = document.getElementById("table-filter");
        tableFilter.style.display = (tableFilter.style.display === "none") ? "block" : "none";
    }

    //on change sort and filter
    onChangeFilter(e) {
        const filterProperties = e.value;

        switch (filterProperties) {
            // case "newest-date":
            // 	this.orderBy="date";
            // 	this.orderAsc=false;
            // 	break;
            // case "oldest-date":
            // 	this.orderBy="date";
            // 	this.orderAsc=true;
            // 	break;
            case "pending-order":
                this.statusOrder = "to-process";
                break;
            case "pending-payment":
                this.statusOrder = "pending";
                break;
            case "processing-order":
                this.statusOrder = "processing";
                break;
            case "completed-order":
                this.statusOrder = "completed";
                break;
            case "cancelled-order":
                this.statusOrder = "cancelled";
                break;
            case "sent-order":
                this.statusOrder = "shipped";
                break;
            case "all-order":
                this.statusOrder = "";
                break;
        }
        this.getAllOrders();
    }

    onSearchIdShop() {
        this.searchObjet = {
            idShop: this.idShopSearch
        };
        this.getAllOrders();
    }

    // private getAllShops(): void {
    // 	this.blockUI.start('Loading');

    // 	this.shopsService.getAllShops().subscribe(
    // 		(res) => {
    // 			if (res.success) {
    // 				this.nbShopTotal = res.nbShopTotal;
    // 				this.listShops = res.data;
    // 				this.blockUI.stop();
    // 			}
    // 			else {
    // 				this.blockUI.stop();
    // 				if (res.errorSet.includes('INVALID_PARAMS')) {
    // 					this.toastrService.error('Les paramètres sont invalides');
    // 				} else if (res.errorSet.includes('ERROR_SERVER')) {
    // 					this.toastrService.error('Une erreur serveur est survenue');
    // 				} else {
    // 					this.toastrService.error('Une erreur s\'est produite');
    // 				}
    // 			}
    // 		},
    // 		(error) => {
    // 			this.blockUI.stop();
    // 			// console.error(error);
    // 			this.toastrService.error('Une erreur s\'est produite');
    // 		}
    // 	);
    // }

    openStatusModal() {
        const modalRef = this.hintModalService.open(StatusOrderExplicationComponent);
        // this.hintModalService.open(hint);
    }

    initDataTable() {
        // init icon status '?' for display modal status
        this.status = document.querySelectorAll('.datatable-header-cell-label .status-modal');
        for (let i = 0; i < this.status.length; i++) {
            this.status[0].addEventListener('click', () => {
                this.openStatusModal();
            });
        }
    }

    fixBrowserTooltip(): void {
        let headerTitle = document.querySelectorAll('.datatable-header-cell');

        headerTitle.forEach(element => {
            element.removeAttribute('title');
        });

    }
}
